module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_sinine_eng.c5a97087.svg";